module.exports = __webpack_public_path__ + "img/chuneng.327d204c.png";